module.exports = __webpack_public_path__ + "static/media/logo9.be8b69bc.png";